import { render, staticRenderFns } from "./ProductTagStamp.vue?vue&type=template&id=b76ed622&scoped=true&lang=pug"
import script from "./ProductTagStamp.vue?vue&type=script&lang=js"
export * from "./ProductTagStamp.vue?vue&type=script&lang=js"
import style0 from "./ProductTagStamp.vue?vue&type=style&index=0&id=b76ed622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76ed622",
  null
  
)

export default component.exports